'use client';

import { ChangeEvent, FormEvent, useState, useEffect } from 'react';
import styles from './home.module.css';

export default function ContactForm() {
	const [form, setForm] = useState({ name: '', email: '', description: '', captcha: '' });
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
	const [captchaQuestion, setCaptchaQuestion] = useState({ question: '', answer: 0 });

	const generateCaptcha = () => {
		const num1 = Math.floor(Math.random() * 10) + 1;
		const num2 = Math.floor(Math.random() * 10) + 1;
		const answer = num1 + num2;
		setCaptchaQuestion({
			question: `${num1} + ${num2} = ?`,
			answer: answer
		});
	};

	// Генерируем капчу при загрузке компонента
	useEffect(() => {
		generateCaptcha();
	}, []);

	const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
		const { name, value } = e.target;
		setForm((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async (e: FormEvent) => {
		e.preventDefault();
		
		// Проверка капчи
		if (parseInt(form.captcha) !== captchaQuestion.answer) {
			setSubmitStatus('error');
			generateCaptcha(); // Генерируем новую капчу
			return;
		}

		setIsSubmitting(true);
		setSubmitStatus('idle');

		try {
			const response = await fetch('/api/send-email', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					name: form.name,
					email: form.email,
					description: form.description
				}),
			});

			if (response.ok) {
				setSubmitStatus('success');
				setForm({ name: '', email: '', description: '', captcha: '' });
				generateCaptcha(); // Генерируем новую капчу
			} else {
				setSubmitStatus('error');
				generateCaptcha(); // Генерируем новую капчу
			}
		} catch (error) {
			console.error('Error sending email:', error);
			setSubmitStatus('error');
			generateCaptcha(); // Генерируем новую капчу
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<section className={styles.contact}>
			<h2>КОНТАКТЫ</h2>
			<h3>ФОРМА ОБРАТНОЙ СВЯЗИ</h3>
			
			{submitStatus === 'success' && (
				<div style={{ 
					background: '#d4edda', 
					color: '#155724', 
					padding: '10px', 
					borderRadius: '4px', 
					marginBottom: '20px',
					border: '1px solid #c3e6cb'
				}}>
					✅ Сообщение успешно отправлено! Мы свяжемся с вами в ближайшее время.
				</div>
			)}
			
			{submitStatus === 'error' && (
				<div style={{ 
					background: '#f8d7da', 
					color: '#721c24', 
					padding: '10px', 
					borderRadius: '4px', 
					marginBottom: '20px',
					border: '1px solid #f5c6cb'
				}}>
					❌ Неверный ответ на вопрос или произошла ошибка при отправке. Попробуйте еще раз.
				</div>
			)}
			
			<form className={styles.form} onSubmit={handleSubmit}>
				<input 
					name='name' 
					type='text' 
					placeholder='Ваше имя' 
					value={form.name} 
					onChange={handleChange} 
					required 
					disabled={isSubmitting}
				/>
				<input 
					name='email' 
					type='email' 
					placeholder='Ваш e-mail' 
					value={form.email} 
					onChange={handleChange} 
					required 
					disabled={isSubmitting}
				/>
				<textarea
					name='description'
					rows={4}
					placeholder='Сообщение'
					value={form.description}
					onChange={handleChange}
					required
					disabled={isSubmitting}
				/>
				<div style={{ 
					display: 'flex', 
					alignItems: 'center', 
					gap: '10px',
					marginBottom: '10px'
				}}>
					<span style={{ 
						fontWeight: 'bold',
						background: '#f8f9fa',
						padding: '8px 12px',
						borderRadius: '4px',
						border: '1px solid #dee2e6'
					}}>
						{captchaQuestion.question}
					</span>
					<input
						name='captcha'
						type='number'
						placeholder='Ответ'
						value={form.captcha}
						onChange={handleChange}
						required
						disabled={isSubmitting}
						style={{
							width: '80px',
							padding: '8px',
							border: '1px solid #ccc',
							borderRadius: '4px'
						}}
					/>
					<button 
						type='button' 
						onClick={generateCaptcha}
						disabled={isSubmitting}
						style={{
							padding: '8px 12px',
							background: '#007bff',
							color: 'white',
							border: 'none',
							borderRadius: '4px',
							cursor: 'pointer'
						}}
					>
						🔄
					</button>
				</div>
				<button type='submit' disabled={isSubmitting}>
					{isSubmitting ? 'Отправляем...' : 'Отправить'}
				</button>
			</form>
		</section>
	);
}
